export const GEMBA_WALK_CALLER = 'GEMBA_WALK'
export const HSE_RISK_CALLER = "HSE_RISK"
export const IMPROVEMENT_IDEA_CALLER = "IMPROVEMENT_IDEA"
